import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import { RecoilRoot } from 'recoil'
import { ThemeProvider } from '@material-ui/core/styles'
import './i18n/i18n'
import mainTheme from './themes/mainTheme'

const closeConsole = () => {
    window.console.clear()
    console.log(
        '%cCU-REC',
        'font-weight: bold; font-size: 50px; color: #e76813; text-shadow: 1px 1px 0px black, 1px -1px 0px black, -1px 1px 0px black, -1px -1px 0px black',
    )
    window.console.log = function () {
        window.console.log = function () {
            return false
        }
    }

    window.console.warn = function () {
        window.console.warn = function () {
            return false
        }
    }

    window.console.error = function () {
        window.console.error = function () {
            return false
        }
    }
    window.console.info = function () {
        window.console.info = function () {
            return false
        }
    }
}

const forceRefreshOnVersionMismatch = () => {
    const versionKey = 'CU_REC_APP_VERSION'
    const currentVersion = process.env.REACT_APP_VERSION || 'unknown'
    try {
        const previousVersion = localStorage.getItem(versionKey)
        if (previousVersion && previousVersion !== currentVersion) {
            localStorage.setItem(versionKey, currentVersion)
            console.info(`App version changed from ${previousVersion} to ${currentVersion}; reloading page.`)
            window.location.reload()
            return
        }
        localStorage.setItem(versionKey, currentVersion)
    } catch (error) {
        console.warn('Version check failed', error)
    }
}

if (process.env.REACT_APP_ENVIRONMENT !== 'DEV') {
    // closeConsole()
}

forceRefreshOnVersionMismatch()

ReactDOM.render(
    <BrowserRouter basename={process.env.REACT_APP_APPLICATION_NAME}>
        <RecoilRoot>
            <ThemeProvider theme={mainTheme}>
                <App />
            </ThemeProvider>
        </RecoilRoot>
    </BrowserRouter>,
    document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
